import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

function PhoneVerifCandidate() {
  const [phoneNumber, setPhoneNumber] = useState("");
  // const [verificationId, setVerificationId] = useState(null);
  // const navigate = useNavigate();

  // Format phone number to E.164 format
  // const formatPhoneNumber = (phone) => {
  //   const cleaned = ('' + phone).replace(/\D/g, ''); // Remove all non-numeric characters
  //   return `+${cleaned}`; // Ensure `+` is added
  // };

  // Initialize reCAPTCHA when the component mounts
  
  

  return (
    <div className="mt-5" id="recaptcha">
      <div className="sm:max-w-lg sm:mx-auto my-auto">
        <div className="w-full max-w-full px-3 mx-auto mt-0 md:flex-0 shrink-0">
          <div className="relative z-0 flex flex-col min-w-0 break-words bg-white border-0 shadow-soft-xl rounded-2xl bg-clip-border">
            <div className="p-6 mb-0 text-center bg-white border-b-0 rounded-t-2xl">
              <h5>Continue with Phone Number Verification</h5>
            </div>
            <div className="flex-auto p-6">
              <form>
                <div className="mb-4">
                  <input
                    id="phoneNumber"
                    aria-label="Phone Number"
                    placeholder="Phone Number"
                    className="text-sm focus:shadow-soft-primary-outline leading-5.6 ease-soft block w-full appearance-none rounded-lg border border-solid border-gray-300 bg-white bg-clip-padding py-2 px-3 font-normal text-gray-700 transition-all focus:border-fuchsia-300 focus:bg-white focus:text-gray-700 focus:outline-none focus:transition-shadow"
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                <Link to="/candidate-profile">
                  <button
                    type="submit"
                    className="inline-block w-full px-6 py-3 mt-6 mb-2 font-bold text-center text-white uppercase align-middle transition-all bg-transparent border-0 rounded-lg cursor-pointer active:opacity-85 hover:scale-102 hover:shadow-soft-xs leading-pro text-xs ease-soft-in tracking-tight-soft shadow-soft-md bg-150 bg-x-25 bg-gradient-to-tl from-gray-900 to-slate-800 hover:border-slate-700 hover:bg-slate-700 hover:text-white"
                  >
                    Send OTP
                  </button>
                </Link>
              </form>
              {/* Recaptcha container */}
              <div id="recaptcha-container"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhoneVerifCandidate;
